import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import "./i18n"
import { Provider } from "react-redux"
import store from "./redux/store/store"
import PokalApiConfigurationProvider from "./config/PokalApiConfigurationProvider"
import PatientDataProvider from "./redux/provider/PatientDataProvider"
import SocketController from "./event/abstract/SocketController"
import OnboardingBorderLayout from "./layout/OnboardingBorderLayout"
import OnboardingStepMenu from "./layout/OnboardingStepMenu"
import OnboardingProvider from "./redux/provider/OnboardingProvider"
import RootLayout from "./layout/RootLayout"
import TopMenu from "./layout/TopMenu"
import NavigationController from "./navigation/NavigationController"
import Footer from "./layout/Footer"
import NotificationProvider from "./redux/provider/NotificationProvider"
import ContextMenu from "./layout/ContextMenu"
import ToasterComponent from "./component/ToasterComponent"
import { BrowserRouter } from "react-router-dom"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

root.render(
    <BrowserRouter>
        <Provider store={store}>
            <PokalApiConfigurationProvider>
                <PatientDataProvider>
                    <SocketController>
                        <OnboardingBorderLayout />
                        <OnboardingStepMenu />
                        <OnboardingProvider />
                        <RootLayout>
                            <TopMenu />
                            <NavigationController />
                            <Footer />
                        </RootLayout>
                        <NotificationProvider />
                        <ContextMenu />
                        <ToasterComponent />
                    </SocketController>
                </PatientDataProvider>
            </PokalApiConfigurationProvider>
        </Provider>
    </BrowserRouter>
)
